import React,{useState,useEffect} from 'react'
import {Collapse} from '@material-ui/core'
import Select from 'react-select'
import Chevron from 'assets/icon/chevron.png'
import { CircularProgress } from '@material-ui/core'
import { useDispatch,useSelector } from 'react-redux'
import { getBeranda } from 'redux/actions/forum'
import { setPersist } from 'redux/actions/persist'
import { setReducer } from 'redux/actions/reducer'


export default function Filter() {
    const dispatch = useDispatch()
    const general = useSelector(state => state.general)
    const reducer = useSelector(state => state.reducer)
    const persist = useSelector(state => state.persist)
    const [filter, setfilter] = useState()
    const {forum_filter,search_list,filter_search}=reducer
    const {forum_sort,filter_action,forum_id,channel_id,}=persist
    
    useEffect(() => {
      
    }, [])
    const choiceFilter=(id)=>{
        if(filter_search===id){
            dispatch(setReducer({filter_search:0}))

        }else{
            dispatch(setReducer({filter_search:id}))

        }
    }
    return (
        <div >
            <div className='home-filter'>
                <div className='filter-content'>
                    <div className='kategory-wrapper '>
                        {general.isLoadingTable?
                            <div style={{textAlign:'center'}}>
                                <CircularProgress style={{color:'#ff4e4e'}}  size={35} />
                            </div>
                        :
                            <div>
                                {search_list.map((d,i)=>(
                                    <div onClick={()=>choiceFilter(d.channelId)} className={`kategory-item  ${filter_search===d.channelId&&'active-kat'}`}>
                                        <p className='font-nunito margin-0'>{d.channel}</p>
                                    </div>
                                ))}
                                
                               
                               
                                
                            </div>
                        }
                        
                        
                    </div>
                </div>
               
            </div>
            <br/>
        </div>
    )
}
